import { jsx as e, jsxs as g } from "react/jsx-runtime";
import { faCircleCheck as C, faCircleXmark as w, faCircleExclamation as y, faCircleInfo as h, faSpinnerThird as v } from "@fortawesome/pro-regular-svg-icons";
import { faXmark as T } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon as f } from "@fortawesome/react-fontawesome";
import * as n from "@radix-ui/react-toast";
import { Box as I } from "../box/Box.js";
import { AnimatePresence as N, motion as b } from "framer-motion";
import { twMerge as i } from "tailwind-merge";
const P = "toast-viewport", j = ({
  id: t,
  children: o,
  messageType: r = "success",
  className: a,
  closable: c = !1,
  duration: l = 3500,
  open: s,
  onExit: u,
  size: m = "sm",
  ...x
}) => /* @__PURE__ */ e(N, { onExitComplete: u, children: s && /* @__PURE__ */ e(n.Root, { open: s, forceMount: !0, duration: l, ...x, children: /* @__PURE__ */ e(
  b.div,
  {
    initial: { opacity: 0, y: -50, scale: 0.3 },
    animate: { opacity: 1, y: 0, scale: 1 },
    exit: { opacity: 0.25, y: -50, scale: 0 },
    transition: { type: "spring", duration: 0.5, bounce: 0.3 },
    children: /* @__PURE__ */ g(
      I,
      {
        className: i(
          "pointer-events-auto flex gap-4 p-4 shadow-lg",
          m === "sm" ? "items-center" : "",
          a
        ),
        children: [
          r && r !== "default" && /* @__PURE__ */ e(d, { type: r, size: m }),
          o && /* @__PURE__ */ e(n.Description, { className: "max-w-sm flex-grow", children: o }),
          c && /* @__PURE__ */ e(p, {})
        ]
      }
    )
  },
  `toast-${t}`
) }) }), p = ({ className: t, ...o }) => /* @__PURE__ */ e(
  n.Close,
  {
    className: i(
      "flex h-4 w-4 items-center justify-center rounded p-1 hover:bg-gray-100",
      t
    ),
    ...o,
    "aria-label": "Close notification",
    children: /* @__PURE__ */ e(f, { icon: T })
  }
), d = ({ type: t, className: o, icon: r, size: a, ...c }) => {
  const l = {
    success: C,
    error: w,
    warning: y,
    info: h,
    loading: v
  }[t], s = {
    success: "text-green-500",
    error: "text-red-500",
    warning: "text-warning-500",
    info: "text-blue-500",
    loading: "animate-spin"
  }[t];
  return /* @__PURE__ */ e(
    "div",
    {
      className: i(
        "flex items-center justify-center rounded-lg",
        a === "md" ? "size-10 border border-gray-200" : ""
      ),
      children: /* @__PURE__ */ e(
        f,
        {
          icon: r ?? l,
          size: "lg",
          className: i(s, o),
          ...c
        }
      )
    }
  );
}, V = n.Close, k = n.Provider, A = ({ id: t, className: o, ...r }) => /* @__PURE__ */ e(
  n.Viewport,
  {
    id: P,
    className: i(
      "z-outermost pointer-events-none fixed inset-x-0 top-0 m-0 flex list-none flex-col items-center justify-center gap-2 p-4 outline-0",
      o
    ),
    ...r
  }
), O = k, S = A, X = j, F = d, W = V, $ = p;
export {
  W as Close,
  $ as CloseButton,
  F as Icon,
  O as Provider,
  X as Root,
  P as TOAST_VIEWPORT_ID,
  j as Toast,
  V as ToastClose,
  p as ToastCloseButton,
  d as ToastIcon,
  k as ToastProvider,
  A as ToastViewport,
  S as Viewport
};
